import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../../../admin/admin.service';
import { ProjectsDataSource } from '../../models/professional-services-projects.datasource';
import { ProfessionalServicesService } from '../../professional-services.service';

@Component({
  selector: 'app-service-estimate-components-rate-approval',
  templateUrl: './service-estimate-components-rate-approval.component.html',
  styleUrls: ['./service-estimate-components-rate-approval.component.scss']
})
export class ServiceEstimateComponentsRateApprovalComponent implements OnInit {

  @Input() serviceEstimates: Array<any>;
  displayedColumns: Array<string>;
  dataSource: ProjectsDataSource;
  seId: string;
  isDateAscending: boolean;
  isNameAscending: boolean;
  pageSize: number;
  pagination: any;
  employees: any[];
  selectedEmployeeId: string | null;
  constructor(private projectService: ProfessionalServicesService, private route: ActivatedRoute, private adminService: AdminService) { }

  ngOnInit() {

    this.isDateAscending = true;
    this.isNameAscending = true;
    this.pageSize = 100;
    this.displayedColumns = [
      'projectName',
      'clientName',
      'componentName',
      'createdDate',
      'modifiedDate',
      'approvedDate',
      'createdBy',
      'approvedBy',
      'actions'
    ];
    this.getEmployees();
    this.getTableData();
  }
  clearSelectedEmployee() {
    this.selectedEmployeeId = null;
    this.filterByEmployee();
  }
  getTableData() {
    this.projectService.getSEComponentsPendingRateApproval()
      .subscribe(res => {
        this.serviceEstimates = res;
        this.setTableData();

      });

  }
  filterByEmployee() {
    if (this.selectedEmployeeId) {
      const filteredData = this.serviceEstimates.filter(temp => {
        if (temp.createdByEmployeeId) {
          return temp.createdByEmployeeId == this.selectedEmployeeId
        } else {
          return false;
        }
      });
      this.setTableData(filteredData);
    } else {
      this.setTableData(this.serviceEstimates);
    }
  }

  getEmployees() {
    this.adminService.getAllEmployees()
      .subscribe(httpResult => {
        this.employees = httpResult;
      });
  }
  setTableData(data?: Array<any>) {
    this.dataSource = new ProjectsDataSource();
    let pageAmount = 100;
    if (!data) {
      if (this.pagination) {
        pageAmount = this.pagination.pageSize;
      }
      const initData = this.serviceEstimates.slice(0, pageAmount);
      this.dataSource.setData(initData);
    } else {
      this.dataSource.setData(data);
    }
  }
  pageChangedEventUsages(event: any) {
    this.pagination = event;
    this.pageSize = event.pageSize;
    console.log(event);
    const pagedData = this.serviceEstimates.slice(event.pageIndex * event.pageSize, (event.pageIndex * event.pageSize) + event.pageSize);
    this.setTableData(pagedData);

  }
  sortByProjectName() {
    this.isNameAscending = !this.isNameAscending;
    if (this.isNameAscending) {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const nameOne = a.serviceEstimate.serviceProject.projectName;
        const nameTwo = b.serviceEstimate.serviceProject.projectName;
        if (nameOne < nameTwo) { return -1; }
        if (nameOne > nameTwo) { return 1; }
        return 1;
      }).slice(0, this.pageSize));
    } else {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const nameOne = a.serviceEstimate.serviceProject.projectName;
        const nameTwo = b.serviceEstimate.serviceProject.projectName;
        if (nameOne < nameTwo) { return 1; }
        if (nameOne > nameTwo) { return -1; }
        return 1;
      }).slice(0, this.pageSize));
    }
  }
  sortByClientName() {
    this.isNameAscending = !this.isNameAscending;
    if (this.isNameAscending) {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const nameOne = a.serviceEstimate.serviceProject.client.commonName;
        const nameTwo = b.serviceEstimate.serviceProject.client.commonName;
        if (nameOne < nameTwo) { return -1; }
        if (nameOne > nameTwo) { return 1; }
        return 1;
      }).slice(0, this.pageSize));
    } else {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const nameOne = a.serviceEstimate.serviceProject.client.commonName;
        const nameTwo = b.serviceEstimate.serviceProject.client.commonName;
        if (nameOne < nameTwo) { return 1; }
        if (nameOne > nameTwo) { return -1; }
        return 1;
      }).slice(0, this.pageSize));
    }
  }
  sortByComponentName() {
    this.isNameAscending = !this.isNameAscending;
    if (this.isNameAscending) {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const nameOne = a.componentName;
        const nameTwo = b.componentName;
        if (nameOne < nameTwo) { return -1; }
        if (nameOne > nameTwo) { return 1; }
        return 1;
      }).slice(0, this.pageSize));
    } else {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const nameOne = a.componentName;
        const nameTwo = b.componentName;
        if (nameOne < nameTwo) { return 1; }
        if (nameOne > nameTwo) { return -1; }
        return 1;
      }).slice(0, this.pageSize));
    }
  }
  sortByDate() {
    this.isDateAscending = !this.isDateAscending;
    if (this.isDateAscending) {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const dateOne: any = new Date(a.createdDate);
        const dateTwo: any = new Date(b.createdDate);

        return dateTwo - dateOne;
      }).slice(0, this.pageSize));
    } else {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const dateOne: any = new Date(a.createdDate);
        const dateTwo: any = new Date(b.createdDate);

        return dateOne - dateTwo;
      }).slice(0, this.pageSize));
    }
  }
  sortByApprovedDate() {
    this.isDateAscending = !this.isDateAscending;
    if (this.isDateAscending) {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const dateOne: any = this.getApproverDate(a.approvals);
        const dateTwo: any = this.getApproverDate(b.approvals);
        if (!dateOne)
          return -1;
        else if (!dateTwo)
          return 1;
        else
          return dateOne < dateTwo ? -1 : 1;
      }).slice(0, this.pageSize));
    } else {
      this.setTableData(this.serviceEstimates.sort((a: any, b: any) => {
        const dateOne: any = this.getApproverDate(a.approvals);
        const dateTwo: any = this.getApproverDate(b.approvals);
        if (!dateOne)
          return 1;
        else if (!dateTwo)
          return -1;
        else
          return dateOne < dateTwo ? 1 : -1;
      }).slice(0, this.pageSize));
    }
  }
  getApprover(data: any) {
    let approval = data.sort((a: any, b: any) => {
      const dateOne: any = new Date(a.approvedDate);
      const dateTwo: any = new Date(b.approvedDate);
      return dateTwo - dateOne;
    });
    return approval[0]?.approvedById;
  }
  getApproverDate(data: any) {
    let approval = data.sort((a: any, b: any) => {
      const dateOne: any = new Date(a.approvedDate);
      const dateTwo: any = new Date(b.approvedDate);
      return dateTwo - dateOne;
    });
    return approval[0]?.approvedDate;
  }
  getModifiedDate(data: any) {
    let changed = data.sort((a: any, b: any) => {
      const dateOne: any = new Date(a.createdDate);
      const dateTwo: any = new Date(b.createdDate);
      return dateTwo - dateOne;
    });
    return changed[0]?.createdDate;
  }
}
